import React from 'react';
import { updateAuction, getAuction, uploadTempDownloads } from '../../../../../../models/auctions';
import swal from 'sweetalert';
import i18n from '../../../../../../i18n';
import { Spinner } from 'react-bootstrap';
import FileInput from '../../../../../helpers/fileInput';
import { Plus, Trash2, Download } from 'lucide-react';

export class ContractsTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      auctionId: props.auctionId,
      input: {},
      errors: {},
      contracts: [{ label: '', label_ar: '', file: '' }],
      is_loading: false,
    };
    this.handleContractSubmit = this.handleContractSubmit.bind(this);
    this.appendData = this.appendData.bind(this);
    this.removeContractData = this.removeContractData.bind(this);
    this.setContractJson = this.setContractJson.bind(this);
    this.uploadTempDownloads = this.uploadTempDownloads.bind(this);
  }

  componentDidMount() { this.loadAuction(); }

  async loadAuction() {
    this.setState({ is_loading: true });
    const response = await getAuction(this.state.auctionId);
    let auction = response.data;
    if (auction) {
      if (auction.downloads && auction.downloads.length) this.setState({ contracts: auction.downloads });
      this.setState({ is_loading: false });
    }
  }

  onFileChange = (event, index) => {
    if (event.target.name === 'file') this.uploadTempDownloads(event.target.files[0], index);
  };

  async uploadTempDownloads(file, index) {
    const formData = new FormData();
    formData.append('contractFile', file, file.name);
    const response = await uploadTempDownloads(formData);
    if (response.success) {
      let { contracts } = this.state;
      contracts[index].file = response.data;
      this.setState({ contracts });
    } else {
      swal('Failed', 'Some error occured!! Please make sure that you are uploading valid file.', 'error');
    }
  }

  handleContractSubmit = async (event) => {
    event.preventDefault();
    try {
      let payload = this.state.input;
      payload.is_downloads_update = true;
      payload.downloads = this.state.contracts;
      const response = await updateAuction(payload, this.state.auctionId);
      if (response && response.data && response.data.id) {
        swal(i18n.t('success'), response.message, 'success', { buttons: false, timer: 2000 })
          .catch((r) => swal('Failed', r.message, 'error'));
      } else {
        let msg = 'Not found!!!';
        let msgs = response.message;
        for (const key in msgs) { if (Object.hasOwnProperty.call(msgs, key)) msg += '\n' + msgs[key]; }
        swal('Failed', msg, 'error');
      }
    } catch (err) { console.log(err); }
  };

  appendData(e) { e.preventDefault(); let c = this.state.contracts || []; c.push({ label: '', value: '' }); this.setState({ contracts: c }); }
  removeContractData(key) { let c = this.state.contracts; delete c[key]; this.setState({ contracts: c }); }
  setContractJson(key, event, i) { let c = this.state.contracts; c[i][key] = event.target.value; this.setState({ contracts: c }); }

  render() {
    let contracts = this.state.contracts;
    return (
      <form onSubmit={this.handleContractSubmit}>
        <div className="form-section">
          <div className="section-header">
            <h2>{i18n.t('contracts')}</h2>
            <button type="button" className="button1 button1-secondary" onClick={this.appendData}>
              <Plus size={18} /> {i18n.t('add_new')}
            </button>
          </div>

          {this.state.is_loading && (
            <div style={{ textAlign: 'center', padding: '1rem' }}><Spinner animation="border" /></div>
          )}

          {contracts && contracts.length > 0 && contracts.map((item, i) => (
            <div key={i} className="enquiry-item">
              <div className="form-row">
                <div className="form-field">
                  <label>Label</label>
                  <input type="text" placeholder="Label" value={item.label || ''}
                    onChange={(e) => this.setContractJson('label', e, i)} />
                </div>
                <div className="form-field">
                  <label>Label ({i18n.t('arabic')})</label>
                  <input type="text" placeholder="Label (Arabic)" dir="rtl" value={item.label_ar || ''}
                    onChange={(e) => this.setContractJson('label_ar', e, i)} />
                </div>
              </div>
              <div className="form-row">
                <div className="form-field">
                  <label>Upload a file (Image/PDF/Doc)</label>
                  <FileInput placeholder={i18n.t('choose_file')} className="form-control"
                    name="file" onChange={(e) => this.onFileChange(e, i)} />
                </div>
                <div className="form-field" style={{ justifyContent: 'flex-end' }}>
                  {item.file ? (
                    <a href={item.file} target="_blank" rel="noreferrer" className="button1 button1-secondary"
                      style={{ textDecoration: 'none', textAlign: 'center', marginTop: 'auto' }}>
                      <Download size={16} /> {i18n.t('download')}
                    </a>
                  ) : (
                    <span style={{ color: '#999', fontSize: '13px', marginTop: 'auto' }}>No file uploaded</span>
                  )}
                </div>
              </div>
              {i > 0 && (
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <button type="button" className="button1 button1-danger" onClick={() => this.removeContractData(i)}>
                    <Trash2 size={16} /> {i18n.t('remove')}
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="action-buttons-l2 border-top-light">
          <button type="submit" className="button1 button1-primary">Update Contracts</button>
        </div>
      </form>
    );
  }
}